var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 4,
    fill: "#FDF3E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92285 13.2572L26.6152 13.4375M4.92285 19.0621C4.92285 18.8336 4.92285 17.7671 4.92285 16.4371V19.0621ZM26.6152 19.0621V16.4371V19.0621ZM4.92285 16.4371H26.6152H4.92285ZM4.92285 16.4371C4.92285 15.4444 4.92285 14.3048 4.92285 13.2572V16.4371ZM26.6152 16.4371V13.4375V16.4371ZM4.92285 13.2572C4.92285 12.7561 4.92285 12.2761 4.92285 11.8433C4.92285 11.4809 5.21214 11.1871 5.56901 11.1871H25.969C26.3259 11.1871 26.6152 11.4809 26.6152 11.8434V13.4375L4.92285 13.2572Z",
    stroke: "#F6931E",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2123 11.1875C22.2123 11.1247 22.2123 9.91734 22.2123 9.03104C22.2123 8.77216 22.0057 8.5625 21.7508 8.5625H18.5782C18.3233 8.5625 18.1167 8.77237 18.1167 9.03125V11.1875M9.44659 11.1875V9.21875C9.44659 8.85631 9.73588 8.5625 10.0927 8.5625H12.6774C13.0342 8.5625 13.3235 8.85631 13.3235 9.21875V11.1875H9.44659ZM6.21582 11.1875V6.59375C6.21582 6.23131 6.50511 5.9375 6.86197 5.9375H24.5847C24.9416 5.9375 25.2308 6.23131 25.2308 6.59375V11.1875H6.21582Z",
    stroke: "#F6931E",
    strokeWidth: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleBed);
export default __webpack_public_path__ + "static/media/doubleBed.5c0306b8f3e3177a65adabb06b3b0e0c.svg";
export { ForwardRef as ReactComponent };